import mapper from 'utils/simple-mapper'

const mapping = [
  ['dateOfBirth'],
  ['name'],
  ['surname'],
  ['sport'],
  ['nationality'],
  ['logo'],
  ['id'],
]

export const toAthleteModel = (form) => {
  form.sport = form.sport.id
  return mapper(form, mapping)
}
